import { render, staticRenderFns } from "./sport-pdf.vue?vue&type=template&id=34d39f43&scoped=true"
import script from "./sport-pdf.vue?vue&type=script&lang=ts"
export * from "./sport-pdf.vue?vue&type=script&lang=ts"
import style0 from "./sport-pdf.vue?vue&type=style&index=0&id=34d39f43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d39f43",
  null
  
)

export default component.exports